import { cn } from 'lib/utils';

import type { ReportCategory } from './mock/reports';

type ReportCategoryBadgeProps = {
    category: ReportCategory;
};

const categoryBadgeClass: Record<ReportCategory, string> = {
    'Online Sales': 'reports-badge-online',
    'POS Sales': 'reports-badge-pos',
    'Ticket Scanning': 'reports-badge-ticket-scanning',
    Marketing: 'reports-badge-marketing',
    Attendees: 'reports-badge-attendee-data',
    Accounting: 'reports-badge-accounting',
    Reviews: 'reports-badge-reviews',
    'Event Summary': 'reports-badge-event-totals',
};

export function ReportCategoryBadge({ category }: ReportCategoryBadgeProps) {
    return (
        <span
            className={cn(
                'inline-flex rounded-full px-2 py-0.5 text-[11px] font-medium',
                categoryBadgeClass[category],
            )}
        >
            {category}
        </span>
    );
}
